export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const ADD_NOTIFICATION = "ADD_NOTIFICATION";
export const RESET_NOTIFICATION = "RESET_NOTIFICATION";
export const REMOVE_NOTIFICATION = "REMOVE_NOTIFICATION";
export const SET_CARRIERS = "SET_CARRIERS";
export const SET_MANAGERS = "SET_MANAGERS";
export const SET_USERS = "SET_USERS";
export const SET_CARS = "SET_CARS";
export const SET_DRIVERS = "SET_DRIVERS";
export const SELECT_TRIP = "SELECT_TRIP";
export const SELECT_REQUEST = "SELECT_REQUEST";
export const ROUTES = "ROUTES";
export const REQUESTS = "REQUESTS";
export const ROUTES_UPDATED = "ROUTES_UPDATED";
export const START_DRAG = "START_DRAG";
export const DRAG_OVER_OBJ = "DRAG_OVER_OBJ";
export const SHOW_NEW_TRIP = "SHOW_NEW_TRIP";
export const SHOW_NEW_REQUEST = "SHOW_NEW_REQUEST";
export const SHOW_NEW_CARRIER = "SHOW_NEW_CARRIER";
export const SHOW_NEW_REQUEST_LINK = "SHOW_NEW_REQUEST_LINK";
export const SET_TRIP_CARRIER_HISTORY = "SET_TRIP_CARRIER_HISTORY";
export const SET_LOCATIONS = "SET_LOCATIONS";
export const SET_SIDE_BY_SIDE = "SET_SIDE_BY_SIDE";
export const SET_TRIPLE_MODE = "SET_TRIPLE_MODE";
export const SET_ROLE = "SET_ROLE";
export const MANAGER_NAME = "MANAGER_NAME";
export const MANAGER_ID = "MANAGER_ID";
export const SET_EXTERNAL_NOTIFICATIONS = "SET_EXTERNAL_NOTIFICATIONS";
export const FILTER_DISPATCHER = "FILTER_DISPATCHER";
export const FILTER_MANAGER = "FILTER_MANAGER";
export const SHOW_DRIVER_FORM = "SHOW_DRIVER_FORM";



// WEBPACK FOOTER //
// ./src/store/actions.js